/* eslint-disable react/no-array-index-key */
import React, { useEffect } from 'react';
import { useStore } from 'effector-react';
import { type HSIconSystem, ImageType } from '@types';
import ImageContainer from '@components/ImageContainer';
import Button from '@components/Button';
import { getSysUrl } from '@utils/urlMakers';
import {
  $editingHotspot,
  $editingHotspotApi,
} from '@stores/editingHotspotStores';
import { $playerWidgetsApi } from '@stores/playerWidgets';
import Tip from '@components/Tip';
import Image from '@components/Image';
import { reAddEditingHotspot } from '../../../../hotspot';
import StickSetting from '../StickSetting';
import { selectLibIcons } from '../../../../mediaLib';

function IconSettingSystem() {
  const { hotspot } = useStore($editingHotspot)!;
  const icon = hotspot.icon as HSIconSystem;
  useEffect(() => {
    return () => {
      $playerWidgetsApi.remove('sysIcon');
    };
  }, []);

  const handleSelectIcon = async () => {
    const { sysItems } = await selectLibIcons();
    const item = sysItems?.[0];
    if (!item) return;
    $editingHotspotApi.update((draft) => {
      (draft.icon as HSIconSystem).url = item.url;
      (draft.icon as HSIconSystem).frame = item.frame;
    });
    reAddEditingHotspot();
  };

  return (
    <>
      <ImageContainer className="h-70">
        <div
          className="h-40 w-40 bg-cover bg-no-repeat"
          style={{ backgroundImage: `url(${getSysUrl(icon.url)})` }}
        />
        {icon.frame > 1 && (
          <Image
            src="/imgs/gif-marker.f465f1f6745579e7a00d9798140c9462.png"
            type={ImageType.sysMedia}
            className="absolute right-5 bottom-5 h-16 w-16"
          />
        )}
      </ImageContainer>
      <div className="mt-10 flex items-center justify-between">
        <Tip>官方精选图标库</Tip>
        <Button size="sm" onClick={handleSelectIcon}>
          选择图标
        </Button>
      </div>
      <StickSetting />
      <Button
        className="mt-20 w-full"
        onClick={() => $playerWidgetsApi.add('sysIcon')}
      >
        图标高级设置
      </Button>
    </>
  );
}

export default IconSettingSystem;
